import { render, staticRenderFns } from "./TobSubDialog.vue?vue&type=template&id=e48cdaae&scoped=true"
import script from "./TobSubDialog.vue?vue&type=script&lang=js"
export * from "./TobSubDialog.vue?vue&type=script&lang=js"
import style0 from "./TobSubDialog.vue?vue&type=style&index=0&id=e48cdaae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48cdaae",
  null
  
)

export default component.exports